import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { Dashboard } from '@components/common'
import type { EmptyStateProps } from '@fourthwall/components'
import { HeadContent } from '@fourthwall/components'

import { InfiniteScrollLoader } from '../../../../components/InfiniteScrollLoader/InfiniteScrollLoader'
import { GiftCardsData } from '../../components/GiftCardsData/GiftCardsData'
import { useGiftCardsInfinite } from '../../hooks/useGiftCardsInfinite'

type GiftCardsInfiniteProps = {
  emptyStateProps: EmptyStateProps
}

export const GiftCardsInfinite = ({ emptyStateProps }: GiftCardsInfiniteProps) => {
  const infiniteProps = useGiftCardsInfinite()

  return (
    <>
      <HeadContent title="Gift cards" />
      <Dashboard.Section.Item>
        <InfiniteScroll
          dataLength={infiniteProps.data?.length || 0}
          next={infiniteProps.onLoadMore}
          hasMore={infiniteProps.hasNextPage}
          loader={<InfiniteScrollLoader />}
          scrollableTarget="scrollableDiv"
          style={{ overflow: 'none' }}
        >
          <GiftCardsData
            // @ts-ignore extra empty interface Shop & Memberships are present can't seem to find a solution here
            data={infiniteProps.data || []}
            isLoading={infiniteProps.isLoading}
            emptyStateProps={emptyStateProps}
          />
        </InfiniteScroll>
      </Dashboard.Section.Item>
    </>
  )
}
